/**
 * Outside Weather - via Turing Server proxy
 * Backend: IP geolocation (ipinfo.io) + Open-Meteo, 1hr cache per IP
 * Reduces ipinfo.io requests for scale (e.g. 1M users → cache hits)
 */

import { getCurrentApiUrl } from './environmentStore'

export interface WeatherResult {
  label: string
  value: string
  icon: string
  city?: string
}

export async function fetchWeatherByIP(): Promise<WeatherResult> {
  try {
    const base = getCurrentApiUrl()
    const res = await fetch(`${base}/api/weather`, { signal: AbortSignal.timeout(8000) })
    if (!res.ok) throw new Error('Weather fetch failed')
    const data = (await res.json()) as WeatherResult
    return data
  } catch {
    return {
      label: 'OUTSIDE',
      value: '—',
      icon: 'wb_sunny',
    }
  }
}
